module.exports = __webpack_public_path__ + "static/media/mars6.97edad93.jpg";